import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import { Link as RouterLink } from 'react-router-dom';

function OurWorkPartnering() {
  const globalClasses = globalUseStyles()
  return (
  <ThemeProvider theme={theme}>
    <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={false} md={1}  />
            <Grid item xs={12} md={10}  >
                <Typography align="center"  variant="h3">We love partnering because we get to learn! </Typography>
                <Typography align="center" variant="body1">We aren’t crazy enough to think we know everything. We love working  with people who have a range of skillsets, knowledge, and experience -- technology and otherwise.  </Typography>
                <Button to='/contact' variant="outlined" color="primary" className={'primaryButton centerbtn'} component={RouterLink}>Partner with us</Button>
            </Grid>
            <Grid item xs={false} md={1}  />

        </Grid>
    </Container>
  </ThemeProvider>
  );
};

export default OurWorkPartnering;